<!--Copyright (c) Laserfiche.
Licensed under the MIT License. See LICENSE in the project root for license information.-->

<span class="field-box">
  @switch (lfFieldInfo.fieldType) {
    @case (fieldTypeDateTime) {
      <lfint-date-time-field-component
        [parent_form]="parentForm"
        [lf_field_form_control]="lfFieldFormControl"
        [lf_field_info]="lfFieldInfo"
        [lf_field_value]="lfFieldValue"
        [dynamic_field_value_options]="dynamicFieldValueOptions"
        (fieldValueChange)="onChange($event)"
      >
      </lfint-date-time-field-component>
    }
    @case (fieldTypeString) {
      <lfint-text-field-component
        [parent_form]="parentForm"
        [lf_field_form_control]="lfFieldFormControl"
        [lf_field_info]="lfFieldInfo"
        [lf_field_value]="lfFieldValue"
        [dynamic_field_value_options]="dynamicFieldValueOptions"
        (fieldValueChange)="onChange($event)"
      >
      </lfint-text-field-component>
    }
    @case (fieldTypeDate) {
      <lfint-date-field-component
        [parent_form]="parentForm"
        [lf_field_form_control]="lfFieldFormControl"
        [lf_field_info]="lfFieldInfo"
        [lf_field_value]="lfFieldValue"
        [dynamic_field_value_options]="dynamicFieldValueOptions"
        (fieldValueChange)="onChange($event)"
      >
      </lfint-date-field-component>
    }
    @case (fieldTypeShortInteger) {
      <lfint-number-field-component
        [parent_form]="parentForm"
        [lf_field_form_control]="lfFieldFormControl"
        [lf_field_info]="lfFieldInfo"
        [lf_field_value]="lfFieldValue"
        [dynamic_field_value_options]="dynamicFieldValueOptions"
        (fieldValueChange)="onChange($event)"
      >
      </lfint-number-field-component>
    }
    @case (fieldTypeLongInteger) {
      <lfint-number-field-component
        [parent_form]="parentForm"
        [lf_field_form_control]="lfFieldFormControl"
        [lf_field_info]="lfFieldInfo"
        [lf_field_value]="lfFieldValue"
        [dynamic_field_value_options]="dynamicFieldValueOptions"
        (fieldValueChange)="onChange($event)"
      >
      </lfint-number-field-component>
    }
    @case (fieldTypeList) {
      <lfint-list-field-component
        [parent_form]="parentForm"
        [lf_field_form_control]="lfFieldFormControl"
        [lf_field_info]="lfFieldInfo"
        [lf_field_value]="lfFieldValue"
        [dynamic_field_value_options]="dynamicFieldValueOptions"
        (fieldValueChange)="onChange($event)"
      >
      </lfint-list-field-component>
    }
    @case (fieldTypeNumber) {
      <lfint-number-field-component
        [parent_form]="parentForm"
        [lf_field_form_control]="lfFieldFormControl"
        [lf_field_info]="lfFieldInfo"
        [lf_field_value]="lfFieldValue"
        [dynamic_field_value_options]="dynamicFieldValueOptions"
        (fieldValueChange)="onChange($event)"
      >
      </lfint-number-field-component>
    }
    @case (fieldTypeTime) {
      <lfint-time-field-component
        [parent_form]="parentForm"
        [lf_field_form_control]="lfFieldFormControl"
        [lf_field_info]="lfFieldInfo"
        [lf_field_value]="lfFieldValue"
        [dynamic_field_value_options]="dynamicFieldValueOptions"
        (fieldValueChange)="onChange($event)"
      >
      </lfint-time-field-component>
    }
  }
</span>
